import React from "react";

import BorderedVariation from "@sendmagic/prismic-nextjs/src/components/ContentBlock/variations/bordered";
import DefaultVariation from "@sendmagic/prismic-nextjs/src/components/ContentBlock/variations/default";

const ContentBlock = ({ doc, ...rest }) =>
  doc.slice_label === "bordered_content" ? (
    <BorderedVariation doc={doc} {...rest} />
  ) : (
    <DefaultVariation doc={doc} {...rest} />
  );

export default ContentBlock;
